module.exports = __webpack_public_path__ + "static/media/jared-tarbell-3.fa22972f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/presentation/jared-tarbell-3.jpg
// module id = 334
// module chunks = 11